import { render } from "./RoleDropdownField.vue?vue&type=template&id=5e6da094"
import script from "./RoleDropdownField.vue?vue&type=script&lang=js"
export * from "./RoleDropdownField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__